import auth from '@/middleware/auth'
import { RESOURCE_ORDERS } from '@/shared/constants/resources'

export default [
  {
    path: '/stock',
    meta: {
      middleware: [auth],
      resource: RESOURCE_ORDERS,
      headerVisible: false,
    },
    name: 'stock',
    component: () => import('@/views/stock/List.vue'),
  },
]
